import axios from "axios";
import Config from "../config";

const ZaloPersonalApi = {
    login: (params) => {
        return axios({
            method: "POST",
            url: (Config.url || '') + "/api/zalo-personal/login-qrcode",
            data: params
        });
    },

    searchByPhone: (params) => {
        return axios({
            method: "POST",
            url: (Config.url || '') + "/api/zalo-personal/search-by-phone",
            data: params
        });
    },
    
    sendFriendRequest: (params) => {
        return axios({
            method: "POST",
            url: (Config.url || '') + "/api/zalo-personal/send-friend-request",
            data: params
        });
    },

    sendMessageByUser: (params) => {
        return axios({
            method: "POST",
            url: (Config.url || '') + "/api/zalo-personal/send-message-by-user",
            data: params
        });
    },

    getFriends: (params) => {
        return axios({
            method: "POST",
            url: (Config.url || '') + "/api/zalo-personal/get-friends",
            data: params
        });
    },

    createGroup: (params) => {
        return axios({
            method: "POST",
            url: (Config.url || '') + "/api/zalo-personal/create-group",
            data: params
        });
    },

    getGroupInfo: (params) => {
        return axios({
            method: "POST",
            url: (Config.url || '') + "/api/zalo-personal/get-group-info",
            data: params
        });
    },

    addUserToGroup: (params) => {
        return axios({
            method: "POST",
            url: (Config.url || '') + "/api/zalo-personal/add-user-group",
            data: params
        });
    },

    removeUserFromGroup: (params) => {
        return axios({
            method: "POST",
            url: (Config.url || '') + "/api/zalo-personal/remove-user-group",
            data: params
        });
    }
};

export default ZaloPersonalApi;